import { render } from "./rankQuestion.vue?vue&type=template&id=4cbec3b3&scoped=true"
import script from "./rankQuestion.vue?vue&type=script&lang=js"
export * from "./rankQuestion.vue?vue&type=script&lang=js"

import "./rankQuestion.vue?vue&type=style&index=0&id=4cbec3b3&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbec3b3"]])

export default __exports__